// import axios from "axios";

// // Function to create axios instance with dynamic headers
// const createAxiosInstance = () => {
//   const tokenData = localStorage.getItem("token");

//   const instance = axios.create({
//     baseURL: "${Endpoint}/controllers/api/User/",
//     headers: {
//       Authorization: `Bearer ${tokenData}`,
//     },
//   });

// //   // Add a request interceptor to update the Authorization header
//   instance.interceptors.request.use(
//     (config) => {
//       const updatedToken = localStorage.getItem("token");
//       // console.log("Updated Token:", updatedToken);
//       if (updatedToken) {
//         config.headers.Authorization = `Bearer ${updatedToken}`;
//       }
//       return config;
//     },
//     (error) => {
//       console.error("Request Interceptor Error:", error);
//       return Promise.reject(error);
//     }
//   );

//   return instance;
// };

// // // Create axios instance
// export const axiosInstance = createAxiosInstance();

import axios from "axios";

export const axiosInstance = axios.create({
  baseURL: `https://nursingupdate.in/Nursing/controllers/api/User/`,
  // baseURL: `https://nursingupdate.in/testing_be/backend/controllers/api/User/`,
  // baseURL: `https://nursingupdate.in/testing_be/controllers/api/User/`,
  // baseURL: `http://localhost/vb_nursing_be/controllers/api/User/`,
  // baseURL: `http://localhost/nurs_be/controllers/api/User/`,
  // baseURL: "https://nursingupdate.in/NurNH/controllers/api/User/",
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    const email = localStorage.getItem("email");

    // Add JWT token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // Add email to payload automatically
    if (email) {
      if (config.data instanceof FormData) {
        config.data.append("email", email);
      } else {
        config.data = {
          ...(config.data || {}),
          email,
        };
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);

const tokenErrors = [
  "Authorization header missing.",
  "Invalid Authorization Header.",
  "JWT is empty",
  "header and payload is not set",
  "email payload is empty",
  "token timeout",
  "email id wrong token",
  "Invalid data. Gmail ID is required.",
  "Gmail ID is required"
  // "timeout"
];

axiosInstance.interceptors.response.use(
  (response) => {
    if (tokenErrors.includes(response?.data?.message)) {
      localStorage.clear();
      window.location.href = "/";
    }

    return response;
  },
  (error) => {
    if (tokenErrors.includes(error?.response?.data?.message)) {
      localStorage.clear();
      window.location.href = "/";
    }
    
    return Promise.reject(error);
  }
);